<div class="mat-bg-surface flex flex--column">
  <mat-toolbar>
    <h1>Projects</h1>
    <span class="spacer"></span>
    <div class="cell-actions">
      <button matIconButton (click)="exportProjects()" matTooltip="Export CSV">
        <mat-icon>file_download</mat-icon>
      </button>
      <button matIconButton [disabled]="pending()" [class.rotating]="pending()" (click)="reload()">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <div class="cell-actions">
    <lcm-po-select (poSelected)="filterPo.set($event)"></lcm-po-select>
    <span class="spacer"></span>

    <mat-form-field>
      <mat-label>Upcoming invoices</mat-label>
      <mat-date-range-input [rangePicker]="rangePicker">
        <input matStartDate required placeholder="Start date" [(ngModel)]="upcomingStart" />
        <input matEndDate required placeholder="End date" #endInput [(ngModel)]="upcomingEnd" />
      </mat-date-range-input>
      <mat-hint>Total value: ${{ upcomingInvoices() | number: '.0' }}</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
      <mat-date-range-picker #rangePicker></mat-date-range-picker>
    </mat-form-field>
  </div>

  <table mat-table matSort [dataSource]="source()" multiTemplateDataRows [trackBy]="trackBy">
    <ng-container matColumnDef="Title">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Title</th>
      <td mat-cell *matCellDef="let item">{{ item.Title }}</td>
    </ng-container>

    <ng-container matColumnDef="Description">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Description</th>
      <td mat-cell *matCellDef="let item">{{ item.Description }}</td>
    </ng-container>

    <ng-container matColumnDef="StartDate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Start Date</th>
      <td mat-cell *matCellDef="let item">{{ item.StartDate | date: 'MMMM dd, y' }}</td>
    </ng-container>

    <ng-container matColumnDef="EndDate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>End Date</th>
      <td mat-cell *matCellDef="let item">{{ item.EndDate | date: 'MMMM dd, y' }}</td>
    </ng-container>

    <ng-container matColumnDef="_ToBeInvoiced">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>To be invoiced</th>
      <td mat-cell *matCellDef="let item" [class.mat-text-error]="item._OverdueInvoices > 0">
        ${{ item._ToBeInvoiced | number: '.0-2' }}
      </td>

      <td mat-footer-cell *matFooterCellDef>
        To be invoiced total:
        <br />
        <strong> ${{ toBeInvoicedTotal() | number: '.0-2' }} </strong>
        <br />
        Overdue invoices:
        <br />

        <strong [class]="{ 'mat-text-error': overdueInvoices() }"> ${{ overdueInvoices() | number: '.0-2' }} </strong>
      </td>
    </ng-container>

    <ng-container matColumnDef="_ProductOwner">
      <th mat-header-cell *matHeaderCellDef>Product Owner</th>
      <td mat-cell *matCellDef="let item">{{ item._ProductOwner }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item">
        <div class="cell-actions">
          <a
            matMiniFab
            [routerLink]="['/app/' + productOwnerRouterMapping[item['_Owner'].type] + '/view', item['_Owner'].id]"
          >
            <mat-icon>remove_red_eye</mat-icon>
          </a>
          @if (item.Milestones.length || item.PurchasedHours.length) {
            <mat-icon>{{ expandedRows()[item.Id] ? 'unfold_less' : 'unfold_more' }}</mat-icon>
          }
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="composition">
      <td
        mat-cell
        *matCellDef="let item"
        [attr.colspan]="columnsToShow().length"
        style="padding: 1rem"
        class="mat-bg-primary-container"
      >
        @if (item.Milestones.length) {
          <lcm-milestone-table [source]="item.Milestones" [ownerId]="item._Owner.id" (saved)="reload()" />
        }
        @if (item.PurchasedHours.length) {
          <lcm-purchased-hours-table
            [source]="item.PurchasedHours"
            [ownerType]="item._Owner.type"
            [ownerId]="item._Owner.id"
            (saved)="reload()"
          />
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="footerSpacer">
      <td mat-footer-cell *matFooterCellDef colspan="4"></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToShow()"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToShow()" (click)="expandRow(row.Id)" style="cursor: pointer"></tr>
    <tr mat-row *matRowDef="let row; columns: ['composition']" [hidden]="!expandedRows()[row.Id]"></tr>
    <tr mat-footer-row *matFooterRowDef="['footerSpacer', '_ToBeInvoiced']"></tr>
  </table>
</div>
